import type { TimeRangeState } from '@spa/scenes/Plannings/redux/reducers'
import moment from 'moment'

type Params = {
  restStart: string
  restEnd: string
  timeRange: TimeRangeState
}

function getRoundedOption({ restStart, restEnd, timeRange }: Params) {
  const rangeStart = moment(timeRange.start)
  const rangeEnd = moment(timeRange.end)
  const startIsInRange = rangeStart.isSameOrBefore(moment(restStart), 'day')

  // Since we have rest that starts at 00:00:00 and ends at 00:00:00 (the next day) instead of
  // ending at 23:59:59 we need to remove one minute to properly compute the rounded options
  //
  // @TODO A better fix would be to create rest that ends at 23:59:59
  const endIsInRange = rangeEnd.isSameOrAfter(
    moment(restEnd).add(-1, 'minutes'),
    'day'
  )

  return {
    left: startIsInRange,
    right: endIsInRange
  }
}

export default getRoundedOption
